/**
 * Líneas del comprobante: los productos SIEMPRE se muestran a precio normal y los
 * descuentos (precio por cantidad, promociones, cupones, descuento manual) van al final.
 * Lo usan el vale con QR, la boleta tradicional, el ticket en pantalla y la vista web.
 */
export function saleReceiptLines(sale) {
  const items = (sale?.items || []).map((it) => {
    const cantidad = Number(it.cantidad || 0);
    // El precio por cantidad (tramos) ya viene aplicado en precio_unitario: se muestra ese
    const unit = Number(it.precio_unitario ?? it.precio ?? 0);
    const amount = Math.round(it.subtotal ?? unit * cantidad);
    // Opciones elegidas (local de comidas) van junto al nombre en el vale y la boleta
    // Las opciones con costo ya salen como línea «Agregado …»: junto al nombre van solo las sin costo
    const mods = (it.modificadores || []).filter((m) => !(it.mods_separados && Number(m.precio) > 0)).map((m) => m.nombre).join(", ");
    return { ...it, nombre: mods ? `${it.nombre} (${mods})` : it.nombre, unit_normal: unit, amount_normal: amount };
  });
  const subtotal_normal = items.reduce((a, l) => a + l.amount_normal, 0);

  const discounts = [];
  for (const ap of sale?.applied_promotions || []) {
    if (Number(ap.savings || 0) > 0) {
      discounts.push({ label: `Promo ${ap.nombre}`, value: Number(ap.savings), kind: "PROMO" });
    }
  }
  if (Number(sale?.coupon_discount || 0) > 0) {
    discounts.push({ label: `Cupón ${sale.coupon_code || ""}`.trim(), value: Number(sale.coupon_discount), kind: "CUPON" });
  }
  const manual = Number(sale?.descuento_manual || 0);
  if (manual > 0) {
    const pct = sale.descuento_manual_tipo === "PORCENTAJE" ? ` ${Number(sale.descuento_manual_valor)}%` : "";
    discounts.push({ label: `Descuento manual${pct}`, value: manual, kind: "MANUAL" });
  }
  const cup = Number(sale?.coupon_discount || 0);
  if (Number(sale?.descuento || 0) - manual - cup > 0) {
    discounts.push({
      label: sale.exchange_codigo ? `Descuento Vale Cambio #${sale.exchange_codigo}` : "Descuento",
      value: Number(sale.descuento) - manual - cup, kind: sale.exchange_codigo ? "VALE" : "OTRO",
    });
  }
  const total_descuentos = discounts.reduce((a, d) => a + Number(d.value || 0), 0);

  const extras = [];
  if (Number(sale?.delivery_fee || 0) > 0) {
    extras.push({ label: "Despacho", value: Number(sale.delivery_fee), kind: "DESPACHO" });
  }
  return { items, subtotal_normal, discounts, total_descuentos, extras };
}
